import { styled } from "@obby/components";

export const Box = styled("div", {
  variants: {
    variant: {
      buttonsWrapper: {
        width: "100%",
        flexWrap: "wrap",
        "@sm": {
          flexWrap: "nowrap"
        }
      },
      buttonWrapper: {
        display: "inline-flex",
        minWidth: "12.5rem",
        marginRight: "$3",
        marginBottom: "$3",
        "&:last-child": {
          marginRight: "0"
        }
      },
      containerFluid: {
        width: "100%",
        paddingX: "1rem",
        maxWidth: "75rem",
        marginX: "auto"
      }
    },
    fontSize: {
      medium: {
        fontFamily: "$foundersGroteskCondensed",
        fontWeight: "$3",
        fontSize: "$28",
        lineHeight: "1.2",
        textTransform: "uppercase",

        "@media (min-width: 414px)": {
          fontSize: "$32"
        }
      },
      large: {
        fontFamily: "$foundersGroteskXCondensed",
        fontWeight: "$1",
        fontSize: "$lParagraph",
        lineHeight: "1.2",
        textTransform: "uppercase"
      },
      xLarge: {
        fontFamily: "$foundersGroteskXCondensed",
        textTransform: "uppercase",
        fontWeight: "$1",
        fontSize: "4rem",
        lineHeight: "1",

        "@lg": {
          fontSize: "80px",
          lineHeight: "1"
        }
      }
    }
  }
});

export const FooterBar = styled("div", {
  bottom: "-69px",
  width: "100%",
  position: "fixed",
  zIndex: 500,
  borderTop: "1px solid $athensGray",
  transition: "all 250ms ease-in-out",
  "@sm": {
    display: "none"
  },
  variants: {
    show: {
      true: {
        bottom: 0
      }
    }
  }
});
